import { Container, Grid } from "@mui/material";
import { useEffect, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { UserPermissions } from "../dto/Permissions";
import { userHasPermissions } from "../utils/utils";
import { Backend } from "../services/Backend";

export default function ProfilePageLayout({ children }) {
    const [userCanSeeUploadedDocuments, setUserCanSeeUploadedDocuments] = useState(false);
    const [newMessages, setNewMessages] = useState(false);
    useEffect(() => {
        userHasPermissions(UserPermissions.SeeUploadedDocuments)
            .then(res => setUserCanSeeUploadedDocuments(res));
        Backend.get(`message/check-new`)
            .then(res => setNewMessages(res.status));
    }, []);

    return <Container maxWidth="lg" className="my-5">
        <h1 className="font-bold text-4xl">Profile</h1>
        <br />
        <hr />

        <div className="flex gap-20 pt-5">
            <div className="flex flex-col gap-2 w-[20%] ">
                <NavLink activeClassName="active" to="/profile/info">Personal info</NavLink>
                <NavLink activeClassName="active" to="/profile/messages" className="flex items-center justify-between">
                    Messages
                    {newMessages && <span className="w-2 h-2 mt-1 bg-red-500 rounded-full"></span>}
                </NavLink>
                { userCanSeeUploadedDocuments 
                ? <NavLink activeClassName="active" to="/profile/uploaded-documents">Uploaded documents</NavLink>
                : ""}
                <NavLink activeClassName="active" to="/profile/subscription">Subscription</NavLink>
            </div>
            <div className="w-full">
               { children }
            </div>
        </div>
    </Container>
}